
const restrictNumber = (number, min, max) => {
  if (number < min) return min;
  if (number > max) return max;
  return number;
};

const adaptMobileEvent = event => {
  if (event.changedTouches && event.changedTouches[0]) {
    return event.changedTouches[0];
  }
  return event;
};

export const convertSecondsToTime = time => {
  if (time === Infinity) return '';
  let min = Math.floor(time / 60);
  let sec = Math.floor(time % 60);
  return `${min}:${(sec < 10) ? (`0${sec}`) : sec}`;
};

export const fullScreen = elem => {
  if (elem.requestFullscreen) {
    elem.requestFullscreen();
  } else if (elem.mozRequestFullScreen) { /* Firefox */
    elem.mozRequestFullScreen();
  } else if (elem.webkitRequestFullscreen) { /* Chrome, Safari and Opera */
    elem.webkitRequestFullscreen();
  } else if (elem.msRequestFullscreen) { /* IE/Edge */
    elem.msRequestFullscreen();
  }
};

export const defineClientX = (event, element) => restrictNumber(
  (adaptMobileEvent(event).clientX - element.getBoundingClientRect().left) / element.offsetWidth,
  0, 1,
);

export const defineClientY = (event, element) => restrictNumber(
  (element.getBoundingClientRect().bottom - adaptMobileEvent(event).clientY) / element.offsetHeight,
  0, 1,
);
